// hooks/useBroadcastChannel.js
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import GLOBAL_ACTIONS from "../actions/global-actions";

export const useBroadcastChannelListener = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const bc = new BroadcastChannel('redux-sync');

        bc.onmessage = (event) => {
            const { key, value } = event.data;
            dispatch(GLOBAL_ACTIONS.updateSharedState(key, value)); // You handle updating Redux state here
        };

        return () => bc.close();
    }, []);
};
